export default __webpack_public_path__ + "static/media/YAS0930.34I-42407_-25403_0.7180cb7c.jpg";